<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    if (this.$store.getters.isLoggedIn) {
      this.$store.dispatch('loadPrivacyMobileMask').catch(() => {})
    }
  },
  watch: {
    '$store.state.token'(token) {
      if (token) {
        this.$store.dispatch('loadPrivacyMobileMask').catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
